import { pxToRem, Logotype } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { SIDEBAR_PADDING } from '../config';
export const SidebarMenuHeaderContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${SIDEBAR_PADDING};
  padding: ${SIDEBAR_PADDING};
`;
export const StyledLogotype = styled(Logotype) `
  width: auto;
  height: ${pxToRem(16)};
`;
export const Plogo = styled.img `
  max-width: 100%;
  height: ${pxToRem(32)};
  margin: 0 auto;
`;
export const ToggleButton = styled.button `
  display: flex;
  border: none;
  height: ${pxToRem(32)};
  align-items: center;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin: 0;
`;
